// extracted by mini-css-extract-plugin
export default {"score":"ScoreScreen_score__UUFUb"};